import { Grid } from '@mui/material';
import { AccordionGeneralityFormVM } from 'front-office/view-models/certificate/generality-form';
import MunicipalityList, { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { FormikErrors, FormikTouched } from 'formik';

interface ItalianForeignStateProps {
  isForeign?: boolean;
  onChange: (
    key: keyof AccordionGeneralityFormVM,
    value: AccordionGeneralityFormVM[keyof AccordionGeneralityFormVM]
  ) => void;
  provinceOfBirth?: string;
  municipalityOfBirth?: MunicipalityAnprVM | null;
  locality?: string;
  errors?: FormikErrors<AccordionGeneralityFormVM>;
  touched?: FormikTouched<AccordionGeneralityFormVM>;
}

const ItalianStateComponent = ({
  onChange,
  municipalityOfBirth,
  locality,
  errors,
  touched,
}: ItalianForeignStateProps): React.ReactElement => {
  return (
    <Grid
      item
      container
      spacing={0}
      columnSpacing={{ xs: 0, md: 1 }}
      rowSpacing={1}
      alignItems="center"
    >
      <Grid item xs={12} md={5}>
        <MunicipalityList
          value={municipalityOfBirth || null}
          required
          onChange={(municipality) => onChange('municipalityOfBirth', municipality)}
          label="Comune di nascita"
          id="municipalityOfBirth"
          error={touched?.municipalityOfBirth && Boolean(errors?.municipalityOfBirth)}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Provincia"
          label="Provincia"
          id="provinceOfBirth"
          name="provinceOfBirth"
          fullWidth
          type="text"
          disabled
          variant="outlined"
          value={municipalityOfBirth?.province || ''}
          onChange={(event) => onChange('provinceOfBirth', event.target.value)}
        />
      </Grid>
      <Grid item xs={12} md={7}>
        <PmiTextField
          aria-label="Località"
          label="Località"
          id="locality"
          name="locality"
          fullWidth
          type="text"
          inputProps={{
            maxLength: '120',
          }}
          variant="outlined"
          value={locality || ''}
          onChange={(event) => onChange('locality', event.target.value)}
        />
      </Grid>
    </Grid>
  );
};

ItalianStateComponent.displayName = 'Filters Person section Italian State component';

const ItalianState = memo(ItalianStateComponent);

export default ItalianState as typeof ItalianStateComponent;
